import { useEffect, useRef, useState } from 'react'
import { gsap, prefersReduced } from '../lib/gsap.js'
import useOutsideClose from './hooks/useOutsideClose.js'

// Anchored panel; render inside a `position: relative` parent (.cn-popover-wrap).
// With sheet (default), phones ≤640px get a fixed bottom sheet + backdrop.
export default function Popover({ open, onClose, align = 'left', placement = 'down', sheet = true, className = '', style, children }) {
  const ref = useRef(null)
  const [render, setRender] = useState(open)

  useEffect(() => {
    const el = ref.current
    if (open) {
      gsap.killTweensOf(el)                       // cancel an in-flight exit if reopened mid-close
      if (el) gsap.set(el, { clearProps: 'opacity,transform' }) // undo any partial fade/scale
      setRender(true)
      return
    }
    if (!render) return
    gsap.killTweensOf(el)                          // avoid stacking tweens
    if (prefersReduced() || !el) { setRender(false); return }
    gsap.to(el, {
      opacity: 0, scale: 0.98, duration: 0.12, ease: 'power1.in',
      transformOrigin: `${placement === 'up' ? 'bottom' : 'top'} ${align === 'right' ? 'right' : 'left'}`,
      onComplete: () => setRender(false),
    })
  }, [open]) // eslint-disable-line react-hooks/exhaustive-deps -- render is a latch, not a trigger

  useOutsideClose(ref, open, onClose, { wrapSelector: '.cn-popover-wrap' })
  if (!render) return null

  const cls = ['cn-popover', align === 'right' ? 'cn-popover--right' : '', placement === 'up' ? 'cn-popover--up' : '', sheet ? 'cn-popover--sheet' : '', className]
    .filter(Boolean).join(' ')
  return (
    <>
      {sheet && <div className="cn-popover-backdrop cn-popover-backdrop--sheet" onClick={onClose} />}
      <div ref={ref} className={cls} style={style}>{children}</div>
    </>
  )
}

export function MenuItem({ active = false, danger = false, className = '', ...rest }) {
  return (
    <button
      className={`cn-menu-item ${danger ? 'cn-menu-item--danger' : ''} ${className}`.trim()}
      data-active={active ? 'true' : 'false'}
      {...rest}
    />
  )
}
